<template lang="pug">
b-modal#modal-pop-up-copy(title='ポップアップをコピーします。')
  .row
    .form-group.col-12
      label ポップアップ名
      input(type="text",class="form-control",:value="$store.state.pop_up.name",@input="updateName($event)")
  template(v-slot:modal-footer)
    b-button(variant="default",@click="copy($event)") 複製する
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    redirect_url: String
  },
  methods: {
    async copy(e){
      e.preventDefault()
      await this.$store.dispatch("pop_up/copy")
      location.href = this.redirect_url
    },
    updateName(e){
      e.preventDefault()
      this.$store.commit("pop_up/setName", e.target.value)
    }
  },
  components: {
  },
  async mounted(){
    await Vue.nextTick()
  },
}
</script>
<style lang="scss" scoped>
</style>
